import { useBattleCardsStore } from 'store/battlecards.store';
import { useHistory, useParams } from 'react-router-dom';
import { addFilterAndGetNewFilter } from 'components/Mobile/mobile.utils';
import { mobileAppConfig } from 'components/Mobile/mobileConfig';
import { useProjectTreeStore } from 'store/projectContract.store';
import { useVersionStore } from 'store/version.store';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

export const useHomeQuickLinks = () => {
    const { id } = useParams<{ id: string }>();
    const contract = useProjectTreeStore((state) => state.contract);
    const project = useProjectTreeStore((state) => state.project);
    const version = useVersionStore((state) => state.version);
    const versionDbId = version?.id;
    const { setFilterData } = useBattleCardsStore();
    const history = useHistory();

    const goToQuickLink = (filters: {}) => {
        if (project && contract && versionDbId) {
            const { filterPayload, querystring } = addFilterAndGetNewFilter({
                versionId: versionDbId,
                contractId: contract.id,
                filters: filters,
                projectId: project.id,
            });
            setFilterData(filterPayload);
            const activitiesPathWithParams = `/${AppRoutes.MOBILE}/${mobileAppConfig.activities.link}/${id}?${querystring}`;
            history.push(activitiesPathWithParams);
        }
    };

    return { goToQuickLink };
};
